module.exports = "<div class=\"alert alert-danger bhtp-purchase-warning\">\n    <a href=\"#\" class=\"bhtp-purchase-warning-close\" (click)=\"hideMessage()\" aria-label=\"close\">&times;</a>\n    <span class=\"fa fa-exclamation-triangle\"></span>\n    <span class=\"text\">{{message}}</span>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/typescript/shared/components/alert-boxes/alert-box.component.html
// module id = 1121
// module chunks = 1